
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 6853 973","xmlns":"http://www.w3.org/2000/svg","fill-rule":"evenodd","clip-rule":"evenodd","stroke-linejoin":"round","stroke-miterlimit":"2"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"486.488","cy":"486.488","r":"486.488","fill":"#d00130"}}),_c('circle',{attrs:{"cx":"1662.45","cy":"486.488","r":"486.488","fill":"#d00130"}}),_c('path',{attrs:{"d":"M1626.06 326.738c-16.5 13.5-30.625 23.5-42.375 30s-23.625 11.75-35.625 15.75l-12-66.75c21-7 41.875-18.125 62.625-33.375s36.625-31.375 47.625-48.375h48.75v525h-69v-422.25z","fill":"#fff","fill-rule":"nonzero"}}),_c('g',{attrs:{"fill":"#0b0c0f"}},[_c('circle',{attrs:{"cx":"2838.41","cy":"486.488","r":"486.488"}}),_c('circle',{attrs:{"cx":"4014.38","cy":"486.488","r":"486.488"}}),_c('circle',{attrs:{"cx":"5190.34","cy":"486.488","r":"486.488"}}),_c('circle',{attrs:{"cx":"6366.3","cy":"486.488","r":"486.488"}})])])
          )
        }
      }
    